<template>
  <header class="error-header-primary">
    <div class="header-area">
      <div v-if="poType === 'PO_NORMAL'" class="error-logo">
        <router-link :to="{ name: 'login' }">
          <img src="../../assets/panda_logo.svg" alt="" />
        </router-link>
      </div>
      <div v-else class="error-logo">
        <img src="../../assets/panda_logo.svg" alt="" />
      </div>
    </div>
  </header>
  <div class="error">
    <div class="container">
      <div class="flex justify-between" style="flex-direction: column">
        <div>
          <h2 class="q-mb-md">ERROR</h2>
          <p>
            内部エラーが発生しました。<br />
            問題が解決しない場合は、ヘルプデスクにお問い合わせください。
          </p>
        </div>
        <q-btn
          v-if="poType === 'PO_NORMAL'"
          label="ログイン画面へ戻る"
          outline
          color="primary"
          :to="{ name: 'login' }"
        />
      </div>
      <div class="col image text-center">
        <img src="../../assets/error_panda.svg" alt="" />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import http from '../../common/axios-common';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import loginUserStore from '../../store/loginUserStore';

const poType = ref('');

// ログイン情報取得
const getLoginUser = () => {
  const loginUser = loginUserStore();
  const { po_type } = storeToRefs(loginUser);
  http
    .post('/ctp001001/loginUser')
    .then((response) => {
      // 異常終了の場合
      if (response.data.common.status === ResultStatusCode.ERROR) {
        poType.value = 'UNKNOWN';
      } else {
        // ログインユーザー情報をstoreに設定
        loginUser.setLoginUser(response.data.loginUser);
        poType.value = po_type.value;
      }
    })
    .catch(() => {
      poType.value = 'UNKNOWN';
    });
};

getLoginUser();
</script>
<style scoped>
.error-header-primary {
  background: linear-gradient(to bottom, var(--q-gradientStart), var(--q-gradientEnd));
  height: 50px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2000;
}

.header-area {
  width: 100%;
  height: 100%;
  box-shadow: 0 0 10px 2px rgb(0 0 0 / 20%), 0 0 10px rgb(0 0 0 / 24%);
}
.error-logo {
  width: 192px;
  height: 100%;
  position: relative;
}

.error .q-btn {
  width: 280px;
  margin-bottom: 10px;
  padding: 15px 0;
  background: var(--q-white) !important;
}

.error-logo:after {
  content: '';
  height: calc(100% - 14px);
  position: absolute;
  top: 0;
  right: 0;
  border-left: 1px solid var(--q-whiteBorder);
  margin: 7px 0;
}

.error-logo a {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 20px 0 22px;
  position: relative;
}

.error-logo a:hover {
  background: rgba(255, 255, 255, 0.22);
  transition: background-color 0.3s cubic-bezier(0.25, 0.8, 0.5, 1),
    opacity 0.4s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.error {
  background: var(--q-lightGray);
  position: relative;
  padding: 50px 0;
  height: 100vh;
}
.error .container {
  width: 70%;
  margin: 0 auto;
  padding-top: 100px;
  display: flex;
  justify-content: center;
}
.error .container .image {
  width: 330px;
  flex: none;
  margin-left: 180px;
}
</style>
